/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserSupportDocumentList = {
    readonly id?: number;
    /**
     * The name of the support document.
     */
    name: string;
    /**
     * The UUID of the support document, used to avoid dangling files in S3.
     */
    readonly uuid?: string;
    /**
     * The description of the support document.
     */
    description?: string | null;
    /**
     * The type of the support document. Please be extra careful when filling this field, as the same document type must match across all user types (see comment on user type below).
     */
    document_type: string;
    /**
     * The type of users who can see this support document. If empty, all users can see it. Documents with the requested user type take priority over documents with empty user type, i.e. for the same type of document, the one with the requested user type will be displayed, unless it does not exist, in which case the one with the empty user type will be displayed.
     */
    user_type: UserSupportDocumentList.user_type;
    /**
     * The file extension of the support document.
     */
    readonly extension?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace UserSupportDocumentList {

    /**
     * The type of users who can see this support document. If empty, all users can see it. Documents with the requested user type take priority over documents with empty user type, i.e. for the same type of document, the one with the requested user type will be displayed, unless it does not exist, in which case the one with the empty user type will be displayed.
     */
    export enum user_type {
        DERMPATH = 'dermpath',
        PHYSICIAN = 'physician',
        LAB_ADMIN = 'lab_admin',
        CLINIC_ADMIN = 'clinic_admin',
        DEMO = 'demo',
        ADMIN = 'admin',
    }


}
